<template>
	<div class="p-6 flex flex-col">
		<h2 class="text-3xl font-bold text-gray-900 mb-4">
			{{ __("Welcome") }}
			{{ user.name }},
			{{ __("glad you are here!") }}
		</h2>

		<div v-if="user.type == 'FARMER'" class="contents">
			<user-profile-status
				:user="user"
				:profileStatus="profileStatus"
			></user-profile-status>

			<!--p>{{ __('start_farmer_no_active_offer_title') }}</p>
            <ul class="list-disc pl-4">
                <li>{{ __('start_farmer_no_active_offer_list_item_1') }}</li>
                <li>{{ __('start_farmer_no_active_offer_list_item_2') }}</li>
                <li>{{ __('start_farmer_no_active_offer_list_item_3') }}</li>
            </ul-->
		</div>

		<div v-else-if="locale == 'de'" class="contents">
			<p class="mb-4">
				Machen Sie jetzt Ihr Kauf- und Verkaufsinteresse auf der Karte sichtbar
				und erweitern Sie Ihren Aktionsradius.
			</p>
			<ul class="list-disc pl-4 mb-4">
				<li>Matching-Algorithmus nutzen</li>
				<li>Sammelgebotsfunktion aktvieren</li>
				<li>Interaktion der Nutzer erhöhen</li>
			</ul>
		</div>

		<div v-else class="contents">
			<p class="mb-4">
				Make your buy and sell interests visibile on the map and expand your
				radius of action!
			</p>
			<ul class="list-disc pl-4 mb-4">
				<li>Use the matching algorithm</li>
				<li>Place bulk bids</li>
				<li>Increase interaction with new business partners</li>
			</ul>
		</div>

		<!-- <div>
            <page-link
                acl="can_trade"
                :href="$route('offer_all.index')"
                type="button"
                class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
            >{{ __('Go to my lots') }}</page-link>
        </div> -->

		<!--div>
            <ui-button
                type="button"
                class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
                v-on:click="$bus.$emit('toggle-iframe-modal', $route('offers.create'))"
                label="New offer"
            />
        </div-->

		<div class="contents">
			<p class="mb-4">
				<strong>{{ __("start_invite_friends_title") }}</strong>
			</p>
			<strong class="mb-4">{{ __("start_invite_friends_list_title") }}</strong>
			<ul class="list-decimal pl-4">
				<li>{{ __("start_invite_friends_list_item_1") }}</li>
				<li>{{ __("start_invite_friends_list_item_2") }}</li>
				<li>{{ __("start_invite_friends_list_item_3") }}</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		profileStatus: {
			type: Object,
		},
	},
};
</script>
